import {createRouter, createWebHistory, NavigationGuardNext} from 'vue-router';

// Importa los componentes
import MarketPage from '@/views/Market/MarketPage.vue';
import LoginPage from '@/views/Auth/LogInPage.vue';
import * as Session from "supertokens-web-js/recipe/session";
import CreateListingSuccessComponent from "@/components/screens/Listing/CreateListing/CreateListingSuccessComponent.vue";
import {CustomerProfileService} from "@/services/backend/CustomerService";
import {UserStorageService} from "@/services/backend/UserService";
import RegisterPage from "@/views/Auth/RegisterPage.vue";
import VerifyEmailPage from "@/views/Auth/VerifyEmailPage.vue";
import ForgotPasswordPage from "@/views/Auth/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/views/Auth/ResetPasswordPage.vue";
import TermsConditionsPage from '@/views/Legal/TermsConditionsPage.vue';
import PrivacyPolicyPage from '@/views/Legal/PrivacyPolicyPage.vue';
import CookiesPolicyPage from '@/views/Legal/CookiesPolicyPage.vue';
import { ref } from 'vue';


async function requireAuth(to: any, from: any, next: NavigationGuardNext) {
	const sessionExists = await Session.doesSessionExist();
	if (sessionExists) {
		
		if(to.name !== 'customer_profile') {
			const userId = await Session.getUserId();
			const customerProfile = await CustomerProfileService.getCustomerProfile(userId);
			
			if(customerProfile == null || customerProfile.name === "") {
				next({ name: "customer_profile" });
				return;
			}
			else{
				UserStorageService.setUserData({name: customerProfile.name, id: userId, postalCode: customerProfile.postalCode});
			}
		}
		
		next();
		
	} else {
		next({ name: "home" }); // Redirect to login if not authenticated
	}
}

async function checkUserLoggedData () {
	const sessionExists = await Session.doesSessionExist();
	if (sessionExists) {
		
		const userId = await Session.getUserId();
		const customerProfile = await CustomerProfileService.getCustomerProfile(userId);
		if(customerProfile){
			UserStorageService.setUserData({name: customerProfile.name, id: userId, postalCode: customerProfile.postalCode});
		}
	}
}

const routes = [
	{
		path: "/auth/login",
		name: "login",
		component: LoginPage,
	},
	{
		path: "/auth/verify-email",
		name: "verify_email",
		component: VerifyEmailPage,
	},
	{
		path: "/auth/reset-password",
		name: "reset_password",
		component: ResetPasswordPage,
	},
	{
		path: "/auth/forgot-password",
		name: "forgot_password",
		component: ForgotPasswordPage,
	},
	{
		path: "/auth/register",
		name: "register",
		component: RegisterPage,
	},
	{
		path: "/terms-conditions",
		name: "terms_conditions",
		component: TermsConditionsPage,
	},
	{
		path: "/privacy-policy",
		name: "privacy_policy",
		component: PrivacyPolicyPage,
	},
	{
		path: "/cookies-policy",
		name: "cookies_policy",
		component: CookiesPolicyPage,
	},
	{
		path: '/',
		name: 'home',
		component: MarketPage,
		beforeEnter: checkUserLoggedData
	},
	{
		path: '/listing/:id',
		name: 'listing',
		component: () => import('@/views/Listing/ListingDetails/ListingDetailsPage.vue'),
		props: true
	},
	
	{
		path: '/create',
		component: () => import('@/views/Listing/CreateListing/CreateListingPage.vue'),
		beforeEnter: requireAuth,
		children: [
			{
				path: '',
				name: 'create',
				component: () => import('@/components/screens/Listing/CreateListing/CreateListingSelectComponent.vue'),
			},
			{
				path: 'listing/:type',
				name: 'create_listing',
				component: () => import('@/components/screens/Listing/CreateListing/CreateListingFormComponent.vue'),
				props: true,
			},
			{
				path: 'listing/review/:type',
				name: 'create_listing_review',
				component: () => import('@/components/screens/Listing/CreateListing/CreateListingReviewComponent.vue'),
			},
			{
				path: 'listing/success/:id',
				name: 'create_listing_success',
				component: CreateListingSuccessComponent,
				props: true
			},
			{
				path: 'listing/error/:message',
				name: 'create_listing_error',
				component: CreateListingSuccessComponent,
				props: true
				
			}
		],
	},
	
	{
		path: '/profile',
		name: 'customer_profile',
		component: () => import('@/views/Customer/CustomerProfilePage.vue'),
		beforeEnter: requireAuth,
		props: true
	},
	
	{
		path: '/listing/manage/:id',
		name: 'listing_manage',
		component: () => import('@/views/Listing/ManageListing/ManageListingPage.vue'),
		beforeEnter: requireAuth,
		props: true
	},
	{
		path: '/my-listings',
		name: 'my_listings',
		component: () => import('@/views/Listing/ListingList/ListingListPage.vue'),
		beforeEnter: requireAuth,
	},
	{
		path: '/bids',
		name: 'bids',
		component: () => import('@/views/Bid/BidList/BidListPage.vue'),
		beforeEnter: requireAuth,
	},
	{
		path: '/bids/:id',
		name: 'bid_detail',
		component: () => import('@/views/Bid/BidDetails/BidDetailsPage.vue'),
		beforeEnter: requireAuth,
		props: true,
	},
	{
		path: '/make-bid',
		name: 'make_bid',
		component: () => import('@/views/Bid/MakeBid/MakeBidComponent.vue'),
		beforeEnter: requireAuth,
	},
	{
		path: '/orders',
		name: 'order_list',
		component: () => import('@/views/Order/OrderList/OrderListPage.vue'),
		beforeEnter: requireAuth,
		props: true,
	},
	{
		path: '/orders/:orderId',
		name: 'order_detail',
		component: () => import('@/views/Order/OrderDetail/OrderDetailPage.vue'),
		beforeEnter: requireAuth,
		props: true,
	},
	
	{
		// Ruta de captura (catch-all)
		path: '/:pathMatch(.*)*', // Coincide con cualquier ruta que no esté definida
		redirect: '/', // Redirige a la página principal
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition; // Si se guarda la posición, la reutiliza (ej. cuando usas "atrás")
		} else {
			return { top: 0, behavior: "smooth" }; // Va arriba con animación suave
		}
	}
});

export default router;

